export default "__VITE_ASSET__BT7eSuqn__"